import React from 'react';
import PropTypes from 'prop-types';
import PartyPopper from '../PartyPopper';
import './EmailSuccess.less';

const EmailSuccess = ({labels: {heading, subheading}, height}) => (
    <div className="EmailSuccess" style={{height: `${height}px`}}>
        <PartyPopper />
        <h2 className="EmailSuccess__heading">{heading}</h2>
        <p className="EmailSuccess__subheading">{subheading}</p>
    </div>
);

EmailSuccess.propTypes = {
    height: PropTypes.number,
    labels: PropTypes.shape({
        heading: PropTypes.string,
        subheading: PropTypes.string,
    }),
};

export default EmailSuccess;
